import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

const WHY = [
  ["Win rate", "Up to ~2x", "the typical 20–40% industry baseline*, driven by consent proof, delivery evidence and issuer-specific letters."],
  ["Cost", "15%", "of recovered funds only. $0 if a dispute is lost. No monthly minimum."],
  ["Speed", "Seconds", "to draft a bank-ready letter, not days. Evidence is already sealed when the dispute lands."],
];
const FAQ = [
  ["Will this work for my industry?", "AEGIS has playbooks for high-ticket coaching, education and certifications, SaaS trial-to-paid, and financing/BNPL. Each has its own evidence (attendance, LMS logs, API usage, installment history) and reason-code strategy. Run the calculator above with your own numbers."],
  ["Do you ever submit without me?", "Never. Every representment is staged for your approval, and only the workspace owner can submit. You get a reminder after 24 hours and an escalation before the bank deadline, but nothing is sent automatically."],
  ["How much does it cost?", "15% of the funds we recover. If a dispute is lost, you pay $0. There is no monthly minimum and no upfront fee."],
  ["How long does setup take?", "About a week: connect your processor and deploy the consent modal (week 1), historical analysis (week 2), go live (week 3), then automate (week 4+)."],
];

export const WhyAegis = () => (
  <div data-testid="why-aegis">
    <div className="grid md:grid-cols-3 gap-4">
      {WHY.map(([k, v, d]) => (
        <div key={k} className="border border-white/10 p-6 hover:border-brand/50 transition-colors" data-testid={`why-${k.toLowerCase()}`}>
          <p className="font-mono text-xs tracking-[0.2em] text-accent2">{k.toUpperCase()}</p>
          <p className="text-4xl font-extrabold text-brand mt-3">{v}</p>
          <p className="text-sm text-white/60 mt-2">{d}</p>
        </div>
      ))}
    </div>
    <p className="text-[11px] text-white/35 mt-3">*Illustrative. Industry baselines vary by vertical and reason code.</p>
  </div>
);

export const Pricing = () => (
  <div className="grid md:grid-cols-[1.2fr_1fr] gap-6 items-stretch" data-testid="pricing-block">
    <div className="border border-brand/40 bg-brand/[0.04] p-8">
      <p className="font-mono text-xs tracking-[0.2em] text-brand">PRICING</p>
      <p className="text-5xl md:text-6xl font-extrabold mt-3">15%<span className="text-lg text-white/50 font-normal"> of recovered funds</span></p>
      <ul className="mt-6 space-y-2 text-white/75">
        <li>✓ $0 if a dispute is lost</li><li>✓ No monthly minimum</li><li>✓ Nothing upfront</li><li>✓ Every letter approved by you before it's sent</li>
      </ul>
    </div>
    <div className="border border-white/10 p-8 flex flex-col justify-center gap-3">
      <a href="#roi" className="px-6 py-3 bg-brand text-black font-mono text-sm font-bold text-center" data-testid="pricing-calc-btn">CALCULATE YOUR SAVINGS</a>
      <a href="#chat" className="px-6 py-3 border border-white/20 font-mono text-sm text-center hover:border-brand transition-colors" data-testid="pricing-chat-btn">CHAT WITH MARI</a>
    </div>
  </div>
);

export const Objections = () => (
  <Accordion type="single" collapsible className="border-t border-white/10" data-testid="objections-faq">
    {FAQ.map(([q, a], i) => (
      <AccordionItem key={q} value={`q${i}`} className="border-white/10">
        <AccordionTrigger className="text-left text-base hover:no-underline" data-testid={`faq-q-${i}`}>{q}</AccordionTrigger>
        <AccordionContent className="text-white/65" data-testid={`faq-a-${i}`}>{a}</AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);

export const CaseStudy = () => (
  <div className="grid md:grid-cols-[1fr_1.4fr] gap-6 border border-white/10 p-6 md:p-10" data-testid="case-study">
    <div>
      <p className="font-mono text-[10px] tracking-[0.2em] px-2 py-1 border border-[#FFB800]/50 text-[#FFB800] inline-block" data-testid="case-study-label">ILLUSTRATIVE EXAMPLE</p>
      <h3 className="text-2xl font-extrabold mt-4">E-learning platform · $2M/yr</h3>
      <p className="text-sm text-white/60 mt-3">A composite scenario based on the education playbook, not a real customer.</p>
    </div>
    <dl className="grid grid-cols-2 gap-4">
      {[["Problem", "12% chargeback rate, ~$240k disputed a year, 20% win rate"], ["Solution", "Pre-exam consent, LMS delivery logs, Ethoca intercepts, AI representments"],
        ["Result", "Chargeback rate toward ~7%, win rate toward ~60%"], ["Year 1", "~$90k kept, net of the 15% fee"]].map(([k, v]) => (
        <div key={k} className="border-l-2 border-brand pl-4"><dt className="font-mono text-[10px] tracking-[0.2em] text-accent2">{k.toUpperCase()}</dt><dd className="text-sm text-white/80 mt-1">{v}</dd></div>
      ))}
    </dl>
  </div>
);
